export type ActivityTypeEnum = 'APP' | 'WEB';

export const ActivityTypeEnumValues = {
    App: 'APP' as ActivityTypeEnum,
    Web: 'WEB' as ActivityTypeEnum,
};
